import { SidebarActiontypes } from "./action.types";

export function toggleSidebar(showSidebar: boolean | "" | "responsive") {
  const action: SidebarAction = {
    type: SidebarActiontypes.SET_SHOW_SIDEBAR,
    showSidebar,
  };
  return (dispatch: SidebarDispatchTypes) => dispatch(action);
}
